import { useState } from "react";
import SelectTemplatesComp from "../../notes-fhir/component/SelectTemplatesComp";
import ViewSampleComp from "./ViewSampleComp";

const EpicTemplateComp = ({ handleRadioChange, templatesContent, getNotesTemplate = () => {} }) => {
   const [showAddTemplate, setShowAddTemplate] = useState(false);
   const getTemplateID = (id) => {
      handleRadioChange(id);
   };
   return (
      <>
         <div className="epic-temp-container">
            <div className="d-flex justify-content-between epic-temp-header">
               <h6>Select note type</h6>
               <h5 onClick={() => setShowAddTemplate(true)}>Add new templates +</h5>
            </div>
            <div className="epic-temp-list no-scrollbar">
               <ViewSampleComp templatesContent={templatesContent} getTemplateID={getTemplateID} />
            </div>
         </div>
         {showAddTemplate && (
            <SelectTemplatesComp
               setShowAddTemplate={setShowAddTemplate}
               onModalTapped={() => setShowAddTemplate(false)}
               getNotesTemplate={getNotesTemplate}
            />
         )}
      </>
   );
};

export default EpicTemplateComp;
